import Axios from "../../src/helpers/axios";

export const getUsersOrders = () => {
  return Axios.get("/api/ecommerce/v1/transactions/user");
};
